import {
    SET_LOAN_LIST, SET_DETAIL_LOAN, SET_VA_LOAN, SET_INFO_DOCS_LOAN,
    REQ_LOAN, REQ_LOAN_DONE, REQ_DETAIL_LOAN, REQ_DETAIL_LOAN_DONE,
    SET_INFO_COLLATERAL_LOAN, SET_OFFERING_HISTORY, SET_STATUS_HISTORY,
    SET_MEMO_HISTORY, SET_DIGISIGN_CHECK
} from '../../utils/constants/actionTypes'

const initialState = {
    list : null,
    detail : null,
    loading : false
}   

const loanState = (state = initialState, action) => {
    switch(action.type) {
        case REQ_LOAN :
            return {
                ...state,
                loading : true
            }
        case REQ_LOAN_DONE :
            return {
                ...state,
                loading : false,
            }
        case SET_LOAN_LIST:
            return {
                ...state,
                list : action.payload,
                loading : false
            }
        default :
            return state;
    }
}

const loanDetailState = (state = initialState, action) => {
    switch (action.type) {
        case REQ_DETAIL_LOAN :
            return {
                ...state,
                loading : true
            }
        case REQ_DETAIL_LOAN_DONE :
            return {
                ...state,
                loading : false,
            }
        case SET_DETAIL_LOAN:
            return {
                ...state,
                detail : action.payload,
                loading : false,
            }
        case SET_VA_LOAN:
            return {
                loading : false,
                detail : {
                    ...state.detail, 
                    virtualAccount : action.payload
                },
            }
        case SET_INFO_DOCS_LOAN:
            return {
                loading : false,
                detail : {
                    ...state.detail, 
                    infoDocs : action.payload
                },
            }
        case SET_INFO_COLLATERAL_LOAN:
            return{
                loading : false,
                detail : {
                    ...state.detail, 
                    infoCollateral : action.payload
                }, 
            }
        case SET_OFFERING_HISTORY:
            return{
                loading : false,
                detail : {
                    ...state.detail, 
                    offeringHistory : action.payload
                }, 
            }
        case SET_STATUS_HISTORY:
            return{
                loading : false,
                detail : {
                    ...state.detail, 
                    statusHistory : action.payload
                }, 
            }
        case SET_MEMO_HISTORY:
            return{
                loading : false,
                detail : {
                    ...state.detail, 
                    memoHistory : action.payload
                }, 
            }
        case SET_DIGISIGN_CHECK : 
            return {
                loading : false,
                detail : {
                    ...state.detail, 
                    digisignCheck : action.payload
                }
            }
        default :
            return state;
    }
}

export {loanState, loanDetailState};